var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 16.5c-.3 0-.5-.1-.7-.3L6 12.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.8 2.8 6.4-6.4c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-7.1 7.1c-.2.2-.4.3-.7.3z"
  })));
}

export default SvgIconChecked;